import { render, staticRenderFns } from "./V3.vue?vue&type=template&id=0f51c620&scoped=true&"
import script from "./V3.vue?vue&type=script&lang=js&"
export * from "./V3.vue?vue&type=script&lang=js&"
import style0 from "./V3.vue?vue&type=style&index=0&id=0f51c620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51c620",
  null
  
)

export default component.exports